// @flow
import i18n from 'i18next';

export const PDFS = {
  theGuide: {
    fr: () => require('../assets/pdfs/fr/FolloGuide_30-05-19.pdf'),
    en: () => require('../assets/pdfs/en/FolloGuide_30-05-19.pdf'),
    default: () => require('../assets/pdfs/en/FolloGuide_30-05-19.pdf'),
  },
  folloCreateCampaign: {
    fr: () => require('../assets/pdfs/fr/01_Follo_creation_campagne.pdf'),
    en: () => require('../assets/pdfs/en/01_Follo_create_campaign.pdf'),
    default: () => require('../assets/pdfs/en/01_Follo_create_campaign.pdf'),
  },
  folloAddBroadcastTime: {
    fr: () => require('../assets/pdfs/fr/02_Follo_ajout_heures_diffusion.pdf'),
    en: () => require('../assets/pdfs/en/02_Follo_Adding_broadcast_campaign.pdf'),
    default: () => require('../assets/pdfs/en/02_Follo_Adding_broadcast_campaign.pdf'),
  },
  folloCampaignPerformance: {
    fr: () => require('../assets/pdfs/fr/03_Follo_Acceder_performance_campagne.pdf'),
    en: () => require('../assets/pdfs/en/03_Follo_Access_campaign_performance.pdf'),
    default: () => require('../assets/pdfs/en/03_Follo_Access_campaign_performance.pdf'),
  },
  folloCompleteCampaign: {
    fr: () => require('../assets/pdfs/fr/04_Follo_Terminer_campagne.pdf'),
    en: () => require('../assets/pdfs/en/04_Follo_Complete_campaign.pdf'),
    default: () => require('../assets/pdfs/en/04_Follo_Complete_campaign.pdf'),
  },
};

function getPDFUrl(pdf: string) {
  const language = i18n.language;

  const pdfs = PDFS[pdf];
  if (!pdfs) {
    return undefined;
  }

  return (pdfs[language] || pdfs.default)();
}

const PDFS_IMPORTERS = Object.keys(PDFS)
  .reduce((acc, pdf) => {
    acc[pdf] = () => getPDFUrl(pdf);
    return acc;
  }, {});

export default PDFS_IMPORTERS;



// WEBPACK FOOTER //
// ./src/advertisers/modules/tutorials/domain/pdfs.js